
export interface KnowledgeEntry {
  id: string;
  theme: string;
  concept: string;
  details: string;
  sourceDoc: string; // e.g., "Six Dharmas" or "Milarepa"
}

export const KNOWLEDGE_BASE: KnowledgeEntry[] = [
  {
    id: 'kb1',
    theme: "Illusion & Reality",
    concept: "Illusory Body (sgyu lus)",
    details: "Recognizing the dream-like and impermanent nature of one's body and all phenomena. All appearances are like reflections in a mirror, empty of inherent existence, just as one's own body is.",
    sourceDoc: "Six Dharmas of Naropa / Milarepa"
  },
  {
    id: 'kb2',
    theme: "Mind & Consciousness",
    concept: "Clear Light ('od gsal)",
    details: "Accessing the fundamental, radiant nature of the mind, often obscured by conceptual thought and emotions. It is the innate luminosity that appears most vividly at the moment of death and during deep meditation.",
    sourceDoc: "Six Dharmas of Naropa"
  },
  {
    id: 'kb3',
    theme: "Transformation & Path",
    concept: "Inner Heat (gtum mo / Tummo)",
    details: "A practice involving visualization and breathing to generate inner psychic heat, purifying the subtle body, dissolving energetic blockages, and generating profound bliss and meditative stability. Aims to burn away negative karmas and defilements.",
    sourceDoc: "Six Dharmas of Naropa / Milarepa"
  },
  {
    id: 'kb4',
    theme: "Illusion & Reality",
    concept: "Dream Yoga (rmi lam)",
    details: "Practices for maintaining awareness during dreams, transforming dream content, and realizing the illusory nature of waking reality. Recognizing dreams as illusions similar to waking life.",
    sourceDoc: "Six Dharmas of Naropa"
  },
  {
    id: 'kb5',
    theme: "Mind & Consciousness",
    concept: "Bardo",
    details: "The intermediate state between death and rebirth, characterized by fluid and often confusing experiences, visions, and karmic projections. Practices aim to navigate this state with awareness.",
    sourceDoc: "Six Dharmas of Naropa"
  },
  {
    id: 'kb6',
    theme: "Transformation & Path",
    concept: "Mentorship & Lineage (Guru Yoga)",
    details: "The profound significance of a guiding figure (mentor/guru) in transmitting wisdom and guiding the student. Lineage represents an unbroken chain of mentorship and teachings.",
    sourceDoc: "Milarepa / Six Dharmas of Naropa"
  },
  {
    id: 'kb7',
    theme: "Cause & Effect",
    concept: "Karma & Purification",
    details: "Actions have consequences that shape experiences across lifetimes. Transformation involves confronting and purifying past harmful actions through dedicated practice and remorse.",
    sourceDoc: "Milarepa"
  },
  {
    id: 'kb8',
    theme: "Illusion & Reality",
    concept: "Emptiness (Sunyata)",
    details: "The understanding that all phenomena lack inherent, independent existence. Realizing emptiness helps dismantle the root of suffering and attachment.",
    sourceDoc: "Six Dharmas of Naropa / Milarepa"
  },
  {
    id: 'kb9',
    theme: "Transformation & Path",
    concept: "Resilience & Overcoming Adversity",
    details: "The journey of self-discovery often involves intense hardship, which serves as a catalyst for rapid spiritual evolution and purification of past negative actions.",
    sourceDoc: "Milarepa"
  },
  {
    id: 'kb10',
    theme: "Mind & Consciousness",
    concept: "The Nature of Mind",
    details: "The mind's true nature is unbiased, luminous, and interconnected. Realization involves understanding this fundamental ground.",
    sourceDoc: "Milarepa"
  }
];

// Generates a concise summary of the knowledge base for the prompt
export const KNOWLEDGE_BASE_SNIPPETS_SUMMARY: string = KNOWLEDGE_BASE.map(
  entry => `- ${entry.concept} (${entry.theme}): ${entry.details.substring(0, 120)}${entry.details.length > 120 ? '...' : ''}`
).join('\n');
